import memoize from 'lodash/memoize';

class Pixel {
  static decode = color => {
    const pixel = Pixel.getInstance();
    pixel.clear();
    pixel.fill(color);

    return pixel.components;
  };

  static encode = ({r, g, b, a}) => {
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  };

  static getInstance = memoize(() => {
    return new Pixel();
  });

  constructor() {
    const canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = 1;

    this.ctx = canvas.getContext('2d');
  }

  clear() {
    this.ctx.clearRect(0, 0, 1, 1);
  }

  fill(color) {
    this.ctx.fillStyle = color;
    this.ctx.fillRect(0, 0, 1, 1);
  }

  get components() {
    // NB. IE11 is unable to deconstruct an ImageData
    // object, so we're doing it manually

    const {data} = this.ctx.getImageData(0, 0, 1, 1);
    return {
      r: data[0],
      g: data[1],
      b: data[2],
      a: data[3] / 255
    };
  }
}

export const idealTextColor = bgColor => {
  const nThreshold = 105;
  const components = Pixel.decode(bgColor);
  const bgDelta = components.r * 0.299 + components.g * 0.587 + components.b * 0.114;

  return 255 - bgDelta < nThreshold ? '#000000' : '#ffffff';
};

export const idealTextColorAgainstWhite = bgColor => {
  const nThreshold = 105;
  const components = Pixel.decode(bgColor);
  const bgDelta = components.r * 0.299 + components.g * 0.587 + components.b * 0.114;

  return 255 - bgDelta < nThreshold ? '#000000' : bgColor;
};

export const getIdealColors = color => {
  return {
    backgroundColor: color,
    color: idealTextColor(color)
  };
};

export const getIdealTextColor = color => {
  return {
    color: idealTextColor(color)
  };
};

export const getColorRange = (steps = 5) => {
  const getColor = value => {
    const hue = ((1 - value) * 120).toString(10);
    return ['hsl(', hue, ',100%,45%)'].join('');
  };
  const range = [];
  for (let i = 0; i <= steps - 1; i++) {
    range.push(getColor(i / (steps - 1)));
  }
  return range.reverse();
};

export const darken = (color, amount) => {
  const pixel = Pixel.getInstance();
  pixel.clear();
  pixel.fill(color);
  pixel.fill(Pixel.encode({r: 0, g: 0, b: 0, a: amount}));
  return Pixel.encode(pixel.components);
};

export const mix = (color1, color2, amount) => {
  const pixel = Pixel.getInstance();
  const overlay = transparentize(color2, amount);
  pixel.clear();
  pixel.fill(color1);
  pixel.fill(overlay);
  return Pixel.encode(pixel.components);
};

export const transparentize = (color, amount) => {
  const {r, g, b, a} = Pixel.decode(color);
  return Pixel.encode({r, g, b, a: amount * a});
};
